import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { LoginRoutingModule } from './login-routing.module';
import { LoginComponent } from './login.component';
import { OtpComponent } from './otp/otp.component';
import { ResetPasswordComponent } from './resetpassword/resetpassword.component';
import { SignUpComponent } from './signup/signup.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ResetpasswordFormComponent } from './resetpassword-form/resetpassword-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { LoadingAnimationModule } from "../../core/loading-animation/loading-animation.module";
import { FormMessageComponent } from "src/app/core/form-message/form-message.component";


@NgModule({
    declarations: [
        LoginComponent,
        ResetPasswordComponent,
        SignUpComponent,
        OtpComponent,
        ResetpasswordFormComponent,
        LoginFormComponent,
    ],
    exports: [
        LoginComponent,
        SignUpComponent,
        ResetPasswordComponent,
    ],
    imports: [
    CommonModule,
    LoginRoutingModule,
    ReactiveFormsModule,
    LoadingAnimationModule,
    FormMessageComponent
],

})
export class LoginModule { }
